import keycode from 'keycode';
import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js';

import logger from '@src/utils/logger';

const ENABLE_HOTKEYS = false; // TODO GROWTH-3602; need to handle the space key conflict with other keydown handling

export const defaultOptions: VideoJsPlayerOptions = {
  fluid: true,
  restoreEl: true,
  playsinline: true,
  controls: true,
  liveui: true, // https://videojs.com/guides/live/
  preload: 'auto',
  // https://github.com/videojs/http-streaming#overridenative
  html5: {
    vhs: {
      // default is !videojs.browser.IS_ANY_SAFARI
      // https://github.dev/videojs/http-streaming/blob/7e89b551e652feec401b30e8b55b7e346d7feceb/src/videojs-http-streaming.js#L1291
      // set to false if any browser on iphone (IS_ANY_SAFARI means iOS || Safari)
      overrideNative: !(
        videojs.browser.IS_IPHONE && videojs.browser.IS_ANY_SAFARI
      ),
    },
    nativeTextTracks: false,
  },
  ...(ENABLE_HOTKEYS
    ? {
        userActions: {
          hotkeys: function (event: videojs.KeyboardEvent) {
            if (keycode.isEventKey(event, 'Space')) {
              const vjsPlayer = (this as VideoJsPlayer).player_;

              if (!vjsPlayer) return;

              event.preventDefault();
              event.stopPropagation();

              if (!vjsPlayer.adsManagerPlugin?.isAdPlaying?.()) {
                if (vjsPlayer.paused()) {
                  vjsPlayer.play();
                } else {
                  vjsPlayer.pause();
                }
              }
            }
          },
        },
      }
    : null),
  mediaServerURL: 'https://vdo.cdn.hk01.com',
  onError: logger.error,
  onAdError: logger.error,
  enableSourceset: true,
};
